import { Pipe, PipeTransform } from '@angular/core';
  
/*
 * Affiche la couleur correspondant au type du pokémon.
 * Prend en argument le type du pokémon.
 * Exemple d'utilisation:
 *   {{ pokemon.type | pokemonTypeColor }}
*/
@Pipe({name: 'timePipe'})
export class TimePipe implements PipeTransform {
  transform(time: string): string {
  
    let color: string;
    time = (parseInt(time)/60).toFixed(0).toString();
  
    return time;
  
  }
}
